import { Skeleton, Stack, styled } from "@mui/material";
import useBreakpoints from "hooks/useBreakpoint";
import { useMemo, Fragment } from "react";

const RFQSkeleton = ({
  hideButton,
  fullMode,
}: {
  hideButton?: boolean;
  fullMode?: boolean;
}) => {
  const { isMobile } = useBreakpoints();

  const isShorterMode = useMemo(
    () => isMobile || !fullMode,
    [isMobile, fullMode]
  );

  return (
    <StyledRFQSkeleton px={2} py={1.25} spacing={2} direction="row">
      <Stack flex={3} spacing={1}>
        <Skeleton variant="text" height={20} width={148} />
        <Skeleton variant="rounded" height={36} width="100%" />
        <Skeleton variant="text" height={20} width="100%" />
        <Skeleton variant="text" height={20} width="50%" />
        <Skeleton variant="text" height={20} width="50%" />
        {!hideButton && (
          <Fragment>
            <Skeleton variant="text" height={20} width={60} />
            <Skeleton variant="text" height={20} width={148} />
          </Fragment>
        )}
      </Stack>

      {!isShorterMode && (
        <Stack flex={1}>
          <Stack direction="row" spacing={2}>
            <Skeleton variant="circular" height={40} width={40} />
            <Stack flex={1}>
              <Skeleton variant="text" height={20} width={96} />
              <Skeleton variant="text" height={20} width={124} />
              <Skeleton variant="text" height={20} width="100%" />
            </Stack>
          </Stack>
          <Skeleton variant="text" height={20} width="100%" />
          <Skeleton variant="text" height={20} width="100%" />
        </Stack>
      )}
    </StyledRFQSkeleton>
  );
};

const StyledRFQSkeleton = styled(Stack)({
  // height: 220,
  backgroundColor: "#fff",
  borderRadius: 8,
  border: "1px solid #eaecf0",
});

export default RFQSkeleton;
